<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="!mapForm.form.valid"
            [title]="(data.isEditMode? 'Edit' : 'Add') +  ' virtual peer connection'">

  <form #mapForm="ngForm" autocomplete="off" class="main-container">
    <div class="form-row">
      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Name</mat-label>
          <input matInput required [(ngModel)]="data.selectedItem.name" name="name">
        </mat-form-field>
      </div>
      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Type</mat-label>
          <input disabled matInput [(ngModel)]="data.selectedItem.peerConnectionNodeType" name="peerConnectionNodeType">
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>TGRP</mat-label>
          <input required matInput [(ngModel)]="data.selectedItem.tgrp" name="tgrp" maxlength="255">
        </mat-form-field>
      </div>

      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Weight</mat-label>
          <input matInput [(ngModel)]="data.selectedItem.weight" type="number" min="1"
                 max="100" name="weight" required>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Node</mat-label>
          <input disabled matInput [(ngModel)]="data.selectedItem.nodeName" name="armNodeName">
        </mat-form-field>
      </div>
      <div class="form-column-arrow">
        <img class="arrow" src="assets/images/general/leftToRightArrow.png">
      </div>
      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Voip Peer</mat-label>
          <mat-select [(ngModel)]="data.selectedItem.voipPeerId" name="voipPeerId">
            <mat-option *ngFor="let item of data.voipPeers" [value]="item.value">
              {{item.text}}
            </mat-option>
          </mat-select>
          <mat-error>
            Voip Peer is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field *ngIf="data.selectedItem.topologyGroups && data.selectedItem.topologyGroups.length > 0" class="fullWidth">
      <mat-label>Resource Groups</mat-label>
      <div class="resource-groups-names">
        <mat-chip-list aria-label="Resource Groups" disabled>
          <mat-chip *ngFor="let group of data.selectedItem.topologyGroups"
                    [selectable]="false" class="resource-groups-names-chip" title="{{group.name}}">
            {{group.name}}
          </mat-chip>
        </mat-chip-list>
      </div>
    </mat-form-field>
  </form>
</arm-dialog>
